import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import QuestionIcon from '@/components/Ambassador/Common/QuestionIcon';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';

const SpecialReward = () => {
    const { t } = useLang('referral');
    const { locale } = getLocal();

    const list = [
        {
            title: t('special.product_title1'),
            img:
                locale === 'au'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1732534981306/sl_power%20hat.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1732534909534/sl_ds%20(1).png',
        },
        {
            title: t('special.product_title2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1732534971761/Rectangle%2051025.jpg',
        },
    ];

    return (
        <div className={`${styled.SpecialReward}`}>
            <h3 className="title">
                {t('special.title')}
                <QuestionIcon text={t('special.tips')} />
            </h3>
            <p className="desc">{t('special.desc')}</p>
            <div className="gift-box">
                {list.map((item, index) => (
                    <div className="gift-item" key={index}>
                        <p className="header">{item.title}</p>
                        <div className="img">
                            <EditorImg pc={item.img} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SpecialReward;
